import {
  FaGithub,
  FaLinkedin,
  FaMedium,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="rounded-xl text-gray-600 dark:text-gray-300 text-center p-4 transition-colors duration-300">
      <div className="flex justify-end flex-col space-x-6">
        <div>
          <h3 className="flex justify-end font-semibold text-base text-gray-500 dark:text-gray-400 tracking-widest uppercase mb-3">
            Connect
          </h3>
        </div>
        <div className="flex justify-end flex-row space-x-4">
          <a
            href="https://github.com/oznur-dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub className="text-2xl text-gray-600 dark:text-gray-300 hover:text-gray-400 dark:hover:text-gray-100 transition duration-300" />
          </a>
          <a
            href="https://medium.com/@oznur.dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaMedium className="text-2xl text-gray-600 dark:text-gray-300 hover:text-blue-400 dark:hover:text-blue-300 transition duration-300" />
          </a>
          <a
            href="https://linkedin.com/in/oznur-caldiran"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="text-2xl text-gray-600 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400 transition duration-300" />
          </a>
          <a
            href="https://www.youtube.com/@oznur-dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube className="text-2xl text-gray-600 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-400 transition duration-300" />
          </a>
        </div>
      </div>
      <div>
        <p className="mt-10 text-gray-800 dark:text-gray-500 text-sm">
          © 2025 Öznur Çaldıran. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
